module.exports = __webpack_public_path__ + "img/academy.ba9089bd.svg";